import { NUMBER_PATTERN, TransportMode } from '../../../../../common/constants';
import { DatepickerRangeModel, DatepickerRangeOutput } from '../../../../../common/models';
import { TransportManagementFilterName } from '../constants/transport-management.constant';
import { assignObjectIfPropertyValueValid } from '../../../../../common/utils';
import { DeviationType } from '../../../../models';
import { MonitoringStatus } from '../../../../constants';
import { DeliveryService, Origin, ServiceLevel } from '../../transport/constants/transport-list.constant';
import { FreightMode } from '../../../shipment-transport-order/constants';
import { ListViewMode } from '../../constants';
import { FormBuilder, FormControl, Validators } from '@angular/forms';

export enum TransportManagementTimeFilter {
  EstimatedDepartureTimeLoad = 'estimatedDepartureTimeLoad',
  EstimatedArrivalTimeLoad = 'estimatedArrivalTimeLoad',
  ActualDepartureTimeLoad = 'actualDepartureTimeLoad',
  ActualArrivalTimeLoad = 'actualArrivalTimeLoad',
  PlannedDepartureTimeLoad = 'plannedDepartureTimeLoad',
  PlannedArrivalTimeLoad = 'plannedArrivalTimeLoad',
  EstimatedDepartureTimeTOAndWaybill = 'estimatedDepartureTimeTOAndWaybill',
  EstimatedArrivalTimeTOAndWaybill = 'estimatedArrivalTimeTOAndWaybill',
  ActualDepartureTimeTOAndWaybill = 'actualDepartureTimeTOAndWaybill',
  ActualArrivalTimeTOAndWaybill = 'actualArrivalTimeTOAndWaybill',
  PlannedDepartureTimeTOAndWaybill = 'plannedDepartureTimeTOAndWaybill',
  PlannedArrivalTimeTOAndWaybill = 'plannedArrivalTimeTOAndWaybill',
}

export type TransportManagementTimeFilterTimestampValues = {
  [key in TransportManagementTimeFilter]: DatepickerRangeModel;
};
export type TransportManagementTimeFilterDateValues = {
  [key in TransportManagementTimeFilter]: DatepickerRangeOutput;
};

export class TransportManagementFiltersBaseModel {
  viewMode?: ListViewMode = ListViewMode.Load;
  [TransportManagementFilterName.TransportModes]: TransportMode[] = [];
  [TransportManagementFilterName.FreightModes]: FreightMode[] = [];
  [TransportManagementFilterName.Statuses]: MonitoringStatus[] = [];
  [TransportManagementFilterName.ServiceLevels]: ServiceLevel[] = [];
  [TransportManagementFilterName.Origins]: Origin[] = [];
  [TransportManagementFilterName.Carriers]: string[] = [];
  [TransportManagementFilterName.Pickups]: string[] = [];
  [TransportManagementFilterName.ShipTos]: string[] = [];
  [TransportManagementFilterName.DeliveryServices]: DeliveryService[] = [];
  [TransportManagementFilterName.TransportOrderNumbers]: string[] = [];
  [TransportManagementFilterName.LoadNumbers]: string[] = [];
  [TransportManagementFilterName.MaterialNumbers]: string[] = [];
  [TransportManagementFilterName.IStarNumbers]: string[] = [];
  [TransportManagementFilterName.Consignors]: string[] = [];
  [TransportManagementFilterName.Consignees]: string[] = [];
  [TransportManagementFilterName.HouseAirwayBills]: string[] = [];
  [TransportManagementFilterName.DeliveryNoteNumbers]: string[] = [];
  [TransportManagementFilterName.ReasonCodes]: string[] = [];
  [TransportManagementFilterName.StatusCodes]: string[] = [];
  [TransportManagementFilterName.HouseBillOfLadings]: string[] = [];
  [TransportManagementFilterName.MasterAirWaybills]: string[] = [];
  [TransportManagementFilterName.MasterBillOfLadings]: string[] = [];
  [TransportManagementFilterName.CarrierTOs]: string[] = [];
  [TransportManagementFilterName.CommercialInvoiceNumbers]: string[] = [];
  [TransportManagementFilterName.PurchaseOrderNumbers]: string[] = [];
  [TransportManagementFilterName.TruckPlates]: string[] = [];
  [TransportManagementFilterName.TrailerPlates]: string[] = [];
  [TransportManagementFilterName.FlightNumbers]: string[] = [];
  [TransportManagementFilterName.VesselNames]: string[] = [];
  [TransportManagementFilterName.DeviationTypes]: DeviationType[] = [];
  [TransportManagementFilterName.DeviationHours]: number = null;
  [TransportManagementFilterName.EquipmentIds]: string[] = [];
  [TransportManagementFilterName.Waybills]: string[] = [];
  [TransportManagementFilterName.MRPControllers]: string[] = [];
  [TransportManagementFilterName.GBs]: string[] = [];
  [TransportManagementFilterName.InboundPlants]: string[] = [];

  constructor(params?: TransportManagementFiltersBaseModel) {
    if (params) {
      Object.assign(this, params);
    }
  }
}

export class TransportManagementFiltersInputModel extends TransportManagementFiltersBaseModel {
  [TransportManagementFilterName.EstimatedDepartureTimeLoad] = new DatepickerRangeModel();
  [TransportManagementFilterName.EstimatedArrivalTimeLoad] = new DatepickerRangeModel();
  [TransportManagementFilterName.EstimatedDepartureTimeTOAndWaybill] = new DatepickerRangeModel();
  [TransportManagementFilterName.EstimatedArrivalTimeTOAndWaybill] = new DatepickerRangeModel();
  [TransportManagementFilterName.ActualDepartureTimeLoad] = new DatepickerRangeModel();
  [TransportManagementFilterName.ActualArrivalTimeLoad] = new DatepickerRangeModel();
  [TransportManagementFilterName.ActualDepartureTimeTOAndWaybill] = new DatepickerRangeModel();
  [TransportManagementFilterName.ActualArrivalTimeTOAndWaybill] = new DatepickerRangeModel();
  [TransportManagementFilterName.PlannedDepartureTimeLoad] = new DatepickerRangeModel();
  [TransportManagementFilterName.PlannedArrivalTimeLoad] = new DatepickerRangeModel();
  [TransportManagementFilterName.PlannedDepartureTimeTOAndWaybill] = new DatepickerRangeModel();
  [TransportManagementFilterName.PlannedArrivalTimeTOAndWaybill] = new DatepickerRangeModel();

  constructor(params?: TransportManagementFiltersInputModel) {
    super();
    if (params) {
      Object.assign(this, params);
    }
  }
}

export class TransportManagementProfileFilterModel extends TransportManagementFiltersInputModel {
  constructor(params?: TransportManagementProfileFilterModel) {
    super();

    if (this.viewMode) {
      delete this.viewMode;
    }

    if (params) {
      assignObjectIfPropertyValueValid(this, params);
    }
  }
}

export class TransportManagementFiltersOutputModel extends TransportManagementFiltersBaseModel {
  [TransportManagementFilterName.EstimatedDepartureTimeLoad] = new DatepickerRangeOutput();
  [TransportManagementFilterName.EstimatedArrivalTimeLoad] = new DatepickerRangeOutput();
  [TransportManagementFilterName.EstimatedDepartureTimeTOAndWaybill] = new DatepickerRangeOutput();
  [TransportManagementFilterName.EstimatedArrivalTimeTOAndWaybill] = new DatepickerRangeOutput();
  [TransportManagementFilterName.ActualDepartureTimeLoad] = new DatepickerRangeOutput();
  [TransportManagementFilterName.ActualArrivalTimeLoad] = new DatepickerRangeOutput();
  [TransportManagementFilterName.ActualDepartureTimeTOAndWaybill] = new DatepickerRangeOutput();
  [TransportManagementFilterName.ActualArrivalTimeTOAndWaybill] = new DatepickerRangeOutput();
  [TransportManagementFilterName.PlannedDepartureTimeLoad] = new DatepickerRangeOutput();
  [TransportManagementFilterName.PlannedArrivalTimeLoad] = new DatepickerRangeOutput();
  [TransportManagementFilterName.PlannedDepartureTimeTOAndWaybill] = new DatepickerRangeOutput();
  [TransportManagementFilterName.PlannedArrivalTimeTOAndWaybill] = new DatepickerRangeOutput();

  constructor(params?: TransportManagementFiltersOutputModel) {
    super();
    if (params) {
      Object.assign(this, params);
    }
  }
}

export class TransportManagementFiltersForm {
  constructor(
    model: TransportManagementFiltersInputModel,
    fb: FormBuilder = new FormBuilder(),
    public viewMode: FormControl<ListViewMode> = fb.control<ListViewMode>(model.viewMode, []),
    public transportModes: FormControl<TransportMode[]> = fb.control<TransportMode[]>(model.transportModes, []),
    public deviationTypes: FormControl<DeviationType[]> = fb.control<DeviationType[]>(model.deviationTypes, []),
    public deviationHours: FormControl<number> = fb.control<number>(model.deviationHours, [
      Validators.pattern(NUMBER_PATTERN),
    ]),
    public freightModes: FormControl<FreightMode[]> = fb.control<FreightMode[]>(model.freightModes, []),
    public statuses: FormControl<MonitoringStatus[]> = fb.control<MonitoringStatus[]>(model.statuses, []),
    public serviceLevels: FormControl<ServiceLevel[]> = fb.control<ServiceLevel[]>(model.serviceLevels, []),
    public origins: FormControl<Origin[]> = fb.control<Origin[]>(model.origins, []),
    public deliveryServices: FormControl<DeliveryService[]> = fb.control<DeliveryService[]>(model.deliveryServices, []),
    public transportOrderNumbers: FormControl<string[]> = fb.control<string[]>(model.transportOrderNumbers, []),
    public loadNumbers: FormControl<string[]> = fb.control<string[]>(model.loadNumbers, []),
    public materialNumbers: FormControl<string[]> = fb.control<string[]>(model.materialNumbers, []),
    public iStarNumbers: FormControl<string[]> = fb.control<string[]>(model.iStarNumbers, []),
    public houseAirwayBills: FormControl<string[]> = fb.control<string[]>(model.houseAirwayBills, []),
    public deliveryNoteNumbers: FormControl<string[]> = fb.control<string[]>(model.deliveryNoteNumbers, []),
    public reasonCodes: FormControl<string[]> = fb.control<string[]>(model.reasonCodes, []),
    public statusCodes: FormControl<string[]> = fb.control<string[]>(model.statusCodes, []),
    public houseBillOfLadings: FormControl<string[]> = fb.control<string[]>(model.houseBillOfLadings, []),
    public masterAirWaybills: FormControl<string[]> = fb.control<string[]>(model.masterAirWaybills, []),
    public masterBillOfLadings: FormControl<string[]> = fb.control<string[]>(model.masterBillOfLadings, []),
    public carrierTOs: FormControl<string[]> = fb.control<string[]>(model.carrierTOs, []),
    public commercialInvoiceNumbers: FormControl<string[]> = fb.control<string[]>(model.commercialInvoiceNumbers, []),
    public purchaseOrderNumbers: FormControl<string[]> = fb.control<string[]>(model.purchaseOrderNumbers, []),
    public truckPlates: FormControl<string[]> = fb.control<string[]>(model.truckPlates, []),
    public trailerPlates: FormControl<string[]> = fb.control<string[]>(model.trailerPlates, []),
    public flightNumbers: FormControl<string[]> = fb.control<string[]>(model.flightNumbers, []),
    public vesselNames: FormControl<string[]> = fb.control<string[]>(model.vesselNames, []),
    public equipmentIds: FormControl<string[]> = fb.control<string[]>(model.equipmentIds, []),
    public carriers: FormControl<string[]> = fb.control<string[]>(model.carriers, []),
    public shipTos: FormControl<string[]> = fb.control<string[]>(model.shipTos, []),
    public pickups: FormControl<string[]> = fb.control<string[]>(model.pickups, []),
    public consignors: FormControl<string[]> = fb.control<string[]>(model.consignors, []),
    public consignees: FormControl<string[]> = fb.control<string[]>(model.consignees, []),
    public waybills: FormControl<string[]> = fb.control<string[]>(model.waybills, []),
    public mrpControllers: FormControl<string[]> = fb.control<string[]>(model.mrpControllers, []),
    public gbs: FormControl<string[]> = fb.control<string[]>(model.gbs, []),
    public inboundPlants: FormControl<string[]> = fb.control<string[]>(model.inboundPlants, []),
    public estimatedDepartureTimeLoad: FormControl<DatepickerRangeOutput> = fb.control<DatepickerRangeOutput>(
      new DatepickerRangeOutput(model.estimatedDepartureTimeLoad),
      [],
    ),
    public estimatedArrivalTimeLoad: FormControl<DatepickerRangeOutput> = fb.control<DatepickerRangeOutput>(
      new DatepickerRangeOutput(model.estimatedArrivalTimeLoad),
      [],
    ),
    public actualDepartureTimeLoad: FormControl<DatepickerRangeOutput> = fb.control<DatepickerRangeOutput>(
      new DatepickerRangeOutput(model.actualDepartureTimeLoad),
      [],
    ),
    public actualArrivalTimeLoad: FormControl<DatepickerRangeOutput> = fb.control<DatepickerRangeOutput>(
      new DatepickerRangeOutput(model.actualArrivalTimeLoad),
      [],
    ),
    public plannedDepartureTimeLoad: FormControl<DatepickerRangeOutput> = fb.control<DatepickerRangeOutput>(
      new DatepickerRangeOutput(model.plannedDepartureTimeLoad),
      [],
    ),
    public plannedArrivalTimeLoad: FormControl<DatepickerRangeOutput> = fb.control<DatepickerRangeOutput>(
      new DatepickerRangeOutput(model.plannedArrivalTimeLoad),
      [],
    ),
    public estimatedDepartureTimeTOAndWaybill: FormControl<DatepickerRangeOutput> = fb.control<DatepickerRangeOutput>(
      new DatepickerRangeOutput(model.estimatedDepartureTimeTOAndWaybill),
      [],
    ),
    public estimatedArrivalTimeTOAndWaybill: FormControl<DatepickerRangeOutput> = fb.control<DatepickerRangeOutput>(
      new DatepickerRangeOutput(model.estimatedArrivalTimeTOAndWaybill),
      [],
    ),
    public actualDepartureTimeTOAndWaybill: FormControl<DatepickerRangeOutput> = fb.control<DatepickerRangeOutput>(
      new DatepickerRangeOutput(model.actualDepartureTimeTOAndWaybill),
      [],
    ),
    public actualArrivalTimeTOAndWaybill: FormControl<DatepickerRangeOutput> = fb.control<DatepickerRangeOutput>(
      new DatepickerRangeOutput(model.actualArrivalTimeTOAndWaybill),
      [],
    ),
    public plannedDepartureTimeTOAndWaybill: FormControl<DatepickerRangeOutput> = fb.control<DatepickerRangeOutput>(
      new DatepickerRangeOutput(model.plannedDepartureTimeTOAndWaybill),
      [],
    ),
    public plannedArrivalTimeTOAndWaybill: FormControl<DatepickerRangeOutput> = fb.control<DatepickerRangeOutput>(
      new DatepickerRangeOutput(model.plannedArrivalTimeTOAndWaybill),
      [],
    ),
  ) {}
}
